export enum OrganizationalUnitsWorkspaceCapabilityAccessOperation {
    create = "ef8b495b-1f4f-4b0b-b38b-d8763555ca94",
    read = "a90be8b6-f92f-46ff-9866-fc63f48962f8",
    update = "e6fd9746-4904-48ed-bd10-f093c756a51d",
    delete = "7f0eb17f-607b-412f-9fe2-f2538ce32921",
}
